<template>
  <div>
    <!--    {{ ruleForm }}-->
    <!--    {{ form }}-->
    <el-form
        ref="ruleFormRef"
        :model="ruleForm"
        :rules="rules"
        class="demo-ruleForm"
        :label-position="'top'"
    >
      <Cards v-if="isShowButton"
             :title="route.query.type==='1' ? $t('common.customer.details') : $t('create.gui.customer')"
             :isShowTitle="true">
        <div id="created_customer"></div>
        <div style="background: white;">
          <slot name="createMessage"></slot>
          <div style="display: flex;align-items: center">
            <div class="gutter_my">
              <el-form-item :label="$t('common.establishment')" prop="setUpTime">
                <el-date-picker
                    size="small"
                    v-model="ruleForm.setUpTime"
                    type="date"
                    :placeholder="$t('sys.tip.select.date')"
                />
              </el-form-item>
            </div>
            <div class="gutter_my">
              <el-form-item :label="$t('common.economicnature')" prop="economicNature">
                <!--              <el-select v-model="ruleForm.economicNature" :placeholder="$t('common.please.select')">-->
                <!--                <el-option :label="$t('common.private.business')" :value="$t('common.private.business')"/>-->
                <!--                <el-option :label="$t('common.stateowned.business')" :value="$t('common.stateowned.business')"/>-->
                <!--              </el-select>-->
                <el-input
                    size="small"
                    v-model="ruleForm.economicNature"
                    :placeholder="$t('common.please.input')"
                />
              </el-form-item>
            </div>
            <div class="gutter_my">
              <!--                        {{form.emails}}-->
              <el-form-item prop="email" style="position: relative">
                <MoreCheck :label="$t('common.cds6')" :title="$t('common.emailbox.add')">
                  <el-input size="small" v-model="defaultEmail"
                            @input="handleCheckForm(2)"
                            :placeholder="$t('common.please.input')"/>
                </MoreCheck>
              </el-form-item>
              <span v-if="email!==''"
                    :class="[email==='ok'?'message_sp_inbox_email_ok':'message_sp_inbox_email']">{{ email }}</span>
            </div>
            <div class="gutter_my">
              <el-form-item :label="$t('common.cds2')">
                <el-input
                    size="small"
                    v-model="ruleForm.companyAddress"
                    :placeholder="$t('common.please.input')"
                />
              </el-form-item>
            </div>
            <div class="gutter_my">
              <el-form-item :label="$t('common.other.remark')" prop="companyRemark">
                <el-input
                    size="small"
                    v-model="ruleForm.companyRemark"
                    @click="showTextarea"
                    :placeholder="$t('common.please.input')"
                />
                <el-dialog v-model="otherDesCompanyVisible" :title="$t('common.remark')">
                  <template #default>
                    <el-input
                        size="small"
                        v-model="ruleForm.companyRemark"
                        type="textarea"
                        :rows="5"
                        :placeholder="$t('common.please.input')"
                    />
                  </template>
                  <template #footer style="border-top: 1px solid">
                    <div class="dialog-footer">
                      <el-button size="small" @click="otherDesCompanyVisible = false" style="margin-right: 20px"
                      >{{ $t('common.sss16') }}
                      </el-button
                      >
                      <el-button
                          size="small"
                          type="primary"
                          @click="otherDesCompanyVisible = false"
                      >{{ $t('common.save') }}
                      </el-button
                      >
                    </div>
                  </template>
                </el-dialog>
              </el-form-item>
            </div>
          </div>
          <div style="display: flex;align-items: center">
            <div :class="['gutter_my']">
              <el-form-item prop="phone">
                <MoreCheck :label="$t('more.check.phone')" :title="$t('common.contact.phone.add')">
                  <el-input
                      size="small"
                      v-model="defaultPhoneNumber"
                      :placeholder="$t('common.please.input')"
                  />
                </MoreCheck>
              </el-form-item>
            </div>
            <div :class="['gutter_my']">
              <el-form-item :label="$t('common.faxnumber')" prop="companyFax">
                <el-input size="small" v-model="ruleForm.companyFax" :placeholder="$t('common.please.input')"/>
              </el-form-item>
            </div>
            <div :class="['gutter_my']" style="position: relative">
              <el-form-item :label="$t('common.company.website')">
                <el-input
                    size="small"
                    v-model="ruleForm.companyWebsite"
                    @input="handleCheckForm(1)"
                    :placeholder="$t('common.please.input')"
                />
              </el-form-item>
              <span v-if="companyWebSite!==''"
                    :class="[companyWebSite==='ok'?'message_sp_inbox_ok':'message_sp_inbox']">{{
                  companyWebSite
                }}</span>
            </div>
            <div class="gutter_my" style="position: relative;z-index: -9999">
              <el-form-item :label="$t('common.bybranch')">
                <el-input
                    size="small"
                    v-model="ruleForm.mangerVOList[0].managerName"
                    :placeholder="$t('common.please.input')"
                    disabled
                />
              </el-form-item>
            </div>
            <div class="gutter_my" style="position: relative;z-index: -9999">
              <el-form-item :label="$t('common.bybranch')">
                <el-input
                    size="small"
                    v-model="ruleForm.mangerVOList[0].managerName"
                    :placeholder="$t('common.please.input')"
                    disabled
                />
              </el-form-item>
            </div>
          </div>
          <div style="display: flex;align-items: center">
            <div class="gutter_my">
              <el-form-item :label="$t('common_customer_level')" prop="customerLevel">
                <el-select
                    size="small"
                    v-model="ruleForm.customerLevel"
                    :placeholder="$t('common.please.select')"
                    @change="selectChange"
                    clearable
                >
                  <el-option
                      v-for="item in selections"
                      :label="item.customerLevel"
                      :value="item.id"
                      :key="item.id"
                  />
                </el-select>
              </el-form-item>
            </div>
            <div class="gutter_my">
              <el-form-item :label="$t('common.customer.type')" prop="customerType">
                <el-input size="small" disabled v-model="selectTarget" :placeholder="$t('common.please.input')"/>
              </el-form-item>
            </div>
            <div class="gutter_my">
              <el-form-item :label="$t('common.interest.product')" prop="product">
                <!--                <el-input size="small" v-model="ruleForm.product" :placeholder="$t('common.please.input')"/>-->
                <SelectEditTag v-model:selectedMember="ruleForm.productList" ref="selectTag"
                               :typeSelect="2" :isOnlyTagFlag="true"></SelectEditTag>
              </el-form-item>
            </div>
            <div class="gutter_my">
              <el-form-item :label="$t('create.customer.des')" prop="marketingRemark">
                <el-input
                    size="small"
                    v-model="ruleForm.marketingRemark"
                    :placeholder="$t('common.please.input')"
                    @click="otherDesSalVisible = true"
                />
                <el-dialog v-model="otherDesSalVisible" :title="$t('create.customer.des')">
                  <template #default>
                    <el-input
                        v-model="ruleForm.marketingRemark"
                        type="textarea"
                        :rows="5"
                        size="small"
                        :placeholder="$t('common.please.input')"
                    />
                  </template>
                  <template #footer style="border-top: 1px solid">
                    <div class="dialog-footer">
                      <el-button size="small" @click="otherDesSalVisible = false" style="margin-right: 20px"
                      >{{ $t('common.sss16') }}
                      </el-button
                      >
                      <el-button
                          size="small"
                          type="primary"
                          @click="otherDesSalVisible = false"
                      >{{ $t('common.save') }}
                      </el-button
                      >
                    </div>
                  </template>
                </el-dialog>
              </el-form-item>
            </div>
            <div class="gutter_my">
              <div style="display: flex;justify-content: center;align-items: center;margin-top: 20px"
                   v-if="isShowButton">
                <el-button size="small" style="margin: 0px 8px !important" @click="reBack"
                >{{ $t('common.back') }}
                </el-button
                >
                <el-button
                    size="small"
                    :loading="saveDataIsLoading"
                    style="margin: 0px 8px !important"
                    type="primary"
                    @click="saveData"
                >{{ $t('common.save') }}
                </el-button
                >
              </div>
            </div>
          </div>
        </div>
      </Cards>
      <template v-else>
        <div id="created_customer"></div>
        <div style="background: white;">
          <slot name="createMessage"></slot>
          <div style="display: flex;align-items: center">
            <div class="gutter_my">
              <el-form-item :label="$t('common.establishment')" prop="setUpTime">
                <el-date-picker
                    size="small"
                    v-model="ruleForm.setUpTime"
                    type="date"
                    :placeholder="$t('sys.tip.select.date')"
                />
              </el-form-item>
            </div>
            <div class="gutter_my">
              <el-form-item :label="$t('common.economicnature')" prop="economicNature">
                <!--              <el-select v-model="ruleForm.economicNature" :placeholder="$t('common.please.select')">-->
                <!--                <el-option :label="$t('common.private.business')" :value="$t('common.private.business')"/>-->
                <!--                <el-option :label="$t('common.stateowned.business')" :value="$t('common.stateowned.business')"/>-->
                <!--              </el-select>-->
                <el-input
                    size="small"
                    v-model="ruleForm.economicNature"
                    :placeholder="$t('common.please.input')"
                />
              </el-form-item>
            </div>
            <div class="gutter_my">
              <!--                        {{form.emails}}-->
              <el-form-item prop="email" style="position: relative">
                <MoreCheck :label="$t('common.cds6')" :title="$t('common.emailbox.add')">
                  <el-input size="small"
                            v-model="defaultEmail"
                            @input="handleCheckForm(2)"
                            :placeholder="$t('common.please.input')"/>
                </MoreCheck>
              </el-form-item>
              <span v-if="email!==''"
                    :class="[email==='ok'?'message_sp_inbox_email_ok':'message_sp_inbox_email']">{{ email }}</span>
            </div>
            <div class="gutter_my">
              <el-form-item :label="$t('common.cds2')">
                <el-input
                    size="small"
                    v-model="ruleForm.companyAddress"
                    :placeholder="$t('common.please.input')"
                />
              </el-form-item>
            </div>
            <div class="gutter_my">
              <el-form-item :label="$t('common.other.remark')" prop="companyRemark">
                <el-input
                    size="small"
                    v-model="ruleForm.companyRemark"
                    @click="showTextarea"
                    :placeholder="$t('common.please.input')"
                />
                <el-dialog v-model="otherDesCompanyVisible" :title="$t('common.remark')">
                  <template #default>
                    <el-input
                        size="small"
                        v-model="ruleForm.companyRemark"
                        type="textarea"
                        :rows="5"
                        :placeholder="$t('common.please.input')"
                    />
                  </template>
                  <template #footer style="border-top: 1px solid">
                    <div class="dialog-footer">
                      <el-button size="small" @click="otherDesCompanyVisible = false" style="margin-right: 20px"
                      >{{ $t('common.sss16') }}
                      </el-button
                      >
                      <el-button
                          size="small"
                          type="primary"
                          @click="otherDesCompanyVisible = false"
                      >{{ $t('common.save') }}
                      </el-button
                      >
                    </div>
                  </template>
                </el-dialog>
              </el-form-item>
            </div>
          </div>
          <div style="display: flex;align-items: center">
            <div :class="['gutter_my']">
              <el-form-item prop="phone">
                <MoreCheck :label="$t('more.check.phone')" :title="$t('common.contact.phone.add')">
                  <el-input
                      size="small"
                      v-model="defaultPhoneNumber"
                      :placeholder="$t('common.please.input')"
                  />
                </MoreCheck>
              </el-form-item>
            </div>
            <div :class="['gutter_my']">
              <el-form-item :label="$t('common.faxnumber')" prop="companyFax">
                <el-input size="small" v-model="ruleForm.companyFax" :placeholder="$t('common.please.input')"/>
              </el-form-item>
            </div>
            <div :class="['gutter_my']" style="position: relative">
              <el-form-item :label="$t('common.company.website')">
                <el-input
                    size="small"
                    v-model="ruleForm.companyWebsite"
                    @input="handleCheckForm(1)"
                    :placeholder="$t('common.please.input')"
                />
              </el-form-item>
              <span v-if="companyWebSite!==''"
                    :class="[companyWebSite==='ok'?'message_sp_inbox_ok':'message_sp_inbox']">{{
                  companyWebSite
                }}</span>
            </div>
            <div class="gutter_my" style="position: relative;z-index: -9999">
              <el-form-item :label="$t('common.bybranch')">
                <el-input
                    size="small"
                    v-model="ruleForm.mangerVOList[0].managerName"
                    :placeholder="$t('common.please.input')"
                    disabled
                />
              </el-form-item>
            </div>
            <div class="gutter_my" style="position: relative;z-index: -9999">
              <el-form-item :label="$t('common.bybranch')">
                <el-input
                    size="small"
                    v-model="ruleForm.mangerVOList[0].managerName"
                    :placeholder="$t('common.please.input')"
                    disabled
                />
              </el-form-item>
            </div>
          </div>
          <div style="display: flex;align-items: center">
            <div class="gutter_my">
              <el-form-item :label="$t('common_customer_level')" prop="customerLevel">
                <el-select
                    size="small"
                    v-model="ruleForm.customerLevel"
                    :placeholder="$t('common.please.select')"
                    @change="selectChange"
                    clearable
                >
                  <el-option
                      v-for="item in selections"
                      :label="item.customerLevel"
                      :value="item.id"
                      :key="item.id"
                  />
                </el-select>
              </el-form-item>
            </div>
            <div class="gutter_my">
              <el-form-item :label="$t('common.customer.type')" prop="customerType">
                <el-input size="small" disabled v-model="selectTarget" :placeholder="$t('common.please.input')"/>
              </el-form-item>
            </div>
            <div class="gutter_my">
              <el-form-item :label="$t('common.interest.product')" prop="product">
                <SelectEditTag v-model:selectedMember="ruleForm.productList" ref="selectTag"
                               :typeSelect="2" :isOnlyTagFlag="true"></SelectEditTag>
              </el-form-item>
            </div>
            <div class="gutter_my">
              <el-form-item :label="$t('create.customer.des')" prop="marketingRemark">
                <el-input
                    size="small"
                    v-model="ruleForm.marketingRemark"
                    :placeholder="$t('common.please.input')"
                    @click="otherDesSalVisible = true"
                />
                <el-dialog v-model="otherDesSalVisible" :title="$t('create.customer.des')">
                  <template #default>
                    <el-input
                        v-model="ruleForm.marketingRemark"
                        type="textarea"
                        :rows="5"
                        size="small"
                        :placeholder="$t('common.please.input')"
                    />
                  </template>
                  <template #footer style="border-top: 1px solid">
                    <div class="dialog-footer">
                      <el-button size="small" @click="otherDesSalVisible = false" style="margin-right: 20px"
                      >{{ $t('common.sss16') }}
                      </el-button
                      >
                      <el-button
                          size="small"
                          type="primary"
                          @click="otherDesSalVisible = false"
                      >{{ $t('common.save') }}
                      </el-button
                      >
                    </div>
                  </template>
                </el-dialog>
              </el-form-item>
            </div>
            <div class="gutter_my">
              <div style="display: flex;justify-content: center;align-items: center;margin-top: 20px"
                   v-if="isShowButton">
                <el-button size="small" style="margin: 0px 8px !important" @click="reBack"
                >{{ $t('common.back') }}
                </el-button
                >
                <el-button
                    size="small"
                    :loading="saveDataIsLoading"
                    style="margin: 0px 8px !important"
                    type="primary"
                    @click="saveData"
                >{{ $t('common.save') }}
                </el-button
                >
              </div>
            </div>
          </div>
        </div>
      </template>
      <Cards :title="$t('common.contact.list')" v-if="isCreate" :isShowTitle="true">
        <div style="display: flex;align-items: center;justify-content: flex-start">
          <el-button
              size="small"
              style="margin-bottom: 20px"
              type="primary"
              @click="handleClickAdd"
          >{{ $t("common.contact.add") }}
          </el-button>
        </div>
        <el-table :key="mainKey"
                  class="tableAuto"
                  v-loading="isLoading"
                  :data="targetTableData"
                  style="width: 100%"
                  :cell-style="rowClassName"
                  :header-cell-style="headerClassName"
                  @cell-mouse-leave="clearVisiblePopover"
        >
          <el-table-column
              v-for="(item, index) in targetMaps"
              :key="item.key"
              :label="item.key"
              :prop="item.value"
              label="Date"
              :width="handleClickSelectWidth(item)"
          >
            <!--            :min-width="handleClickSelectMinWidth(item)"-->
            <template v-if="item.value==='remark'" #default="scope">
              <el-icon
                  :color="scope.row.remark ? '#40a9ff' : '#dddddd'">
                <el-tooltip
                    v-if="scope.row.remark"
                    class="box-item"
                    :content="scope.row.remark"
                    placement="right"
                    popper-class="tips_width"
                >
                  <Memo/>
                </el-tooltip>
                <Memo v-else/>
              </el-icon>
            </template>
            <template v-else-if="item.value==='name'" #default="{row}">
              <div style="display: flex;align-items: center;">
                <el-icon v-if="row?.isMain" style="margin-right: 5px;">
                  <User/>
                </el-icon>
                <div :ref="ref => (refMap[`${row.email}name`] = ref)"
                     @mouseover.stop="handleRef(refMap[`${row.email}name`], row, 1)"
                     class="over_normal"
                     v-if=" getTextLength(row.name) > sizeMaxNumber"
                     :key="row.name">
                  {{
                    getTextLength(row.name) > sizeMaxNumber ? formatText(row.name, sizeMaxNumber) : row.name
                  }}
                </div>
                <div v-else class="over_normal">
                  {{ row.name }}
                </div>
              </div>
            </template>
            <template v-else-if="item.value==='nickName'" #default="{row}">
              <div :ref="ref => (refMap[`${row.email}nickName`] = ref)"
                   @mouseover.stop="handleRef(refMap[`${row.email}nickName`], row, 2)"
                   class="over_normal"
                   v-if=" getTextLength(row.nickName) > sizeMaxNumber"
                   :key="row.nickName">
                {{
                  getTextLength(row.nickName) > sizeMaxNumber ? formatText(row.nickName, sizeMaxNumber) : row.nickName
                }}
              </div>
              <div v-else class="over_normal">
                {{ row.nickName }}
              </div>
            </template>
            <template v-else-if="item.value==='email'" #default="{row}">
              <div :ref="ref => (refMap[`${row.email}email`] = ref)"
                   @mouseover.stop="handleRef(refMap[`${row.email}email`], row, 3)"
                   class="over_normal"
                   v-if=" getTextLength(row.email) > sizeMaxNumber"
                   :key="row.email">
                {{
                  getTextLength(row.email) > sizeMaxNumber ? formatText(row.email, sizeMaxNumber) : row.email
                }}
              </div>
              <div v-else class="over_normal">
                {{ row.email }}
              </div>
            </template>
            <template v-else-if="item.value==='departName'" #default="{row}">
              <div :ref="ref => (refMap[`${row.email}departName`] = ref)"
                   @mouseover.stop="handleRef(refMap[`${row.email}departName`], row, 4)"
                   class="over_normal"
                   v-if=" getTextLength(row.departName) > sizeMaxNumber"
                   :key="row.departName">
                {{
                  getTextLength(row.departName) > sizeMaxNumber ? formatText(row.departName, sizeMaxNumber) : row.departName
                }}
              </div>
              <div v-else class="over_normal">
                {{ row.departName }}
              </div>
            </template>
            <template v-else-if="item.value==='post'" #default="{row}">
              <div :ref="ref => (refMap[`${row.email}post`] = ref)"
                   @mouseover.stop="handleRef(refMap[`${row.email}post`], row, 5)"
                   class="over_normal"
                   v-if=" getTextLength(row.post) > sizeMaxNumber"
                   :key="row.post">
                {{
                  getTextLength(row.post) > sizeMaxNumber ? formatText(row.post, sizeMaxNumber) : row.post
                }}
              </div>
              <div v-else class="over_normal">
                {{ row.post }}
              </div>
            </template>
            <template v-else-if="item.value==='contactPhone'" #default="{row}">
              <div :ref="ref => (refMap[`${row.email}contactPhone`] = ref)"
                   @mouseover.stop="handleRef(refMap[`${row.email}contactPhone`], row, 6)"
                   class="over_normal"
                   v-if=" getTextLength(row.contactPhone) > sizeMaxNumber"
                   :key="row.contactPhone">
                {{
                  getTextLength(row.contactPhone) > sizeMaxNumber ? formatText(row.contactPhone, sizeMaxNumber) : row.contactPhone
                }}
              </div>
              <div v-else class="over_normal">
                {{ row.contactPhone }}
              </div>
            </template>
            <template v-else-if="item.value==='birthday'" #default="{row}">
              <div>
                {{ row.birthday ? row.birthday.split(" ")[0] : "" }}
              </div>
            </template>
            <template v-else-if="item.value==='createTime'" #default="{row}">
              <div :ref="ref => (refMap[`${row.email}createTime`] = ref)"
                   @mouseover.stop="handleRef(refMap[`${row.email}createTime`], row, 7)"
                   class="over_normal"
                   v-if=" getTextLength(row.createTime) > sizeMaxNumber"
                   :key="row.createTime">
                {{
                  getTextLength(row.createTime) > sizeMaxNumber ? formatText(row.createTime, sizeMaxNumber) : row.createTime
                }}
              </div>
              <div v-else class="over_normal">
                {{ row.createTime }}
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('common.operate')" fixed="right" width="120">
            <template #default="{ row, column, $index }">
              <el-button
                  type="primary"
                  link
                  size="small"
                  @click="clickEdit(row, column, $index)"
              >{{ $t('common.edit') }}
              </el-button
              >
              <ConfirmDeletePopover
                  :visible="row.popoverVisible"
                  :width="168"
                  :message="$t('sys.message.ask.contect.delete')"
                  @update:visible="(value) => (row.popoverVisible = value)"
                  @confirm:delete="handleDelete(row, column, $index)"
              >
                <template #settings>
                  <el-button size="small" type="danger" link @click="handleDeleteT(row, column, $index)">
                    {{ $t('common.delete') }}
                  </el-button>
                </template>
              </ConfirmDeletePopover>
            </template>
          </el-table-column>
          <template #empty>
            <el-empty :description="$t('common.data.empty')" :image="emptyUrl"/>
          </template>
        </el-table>
        <!--  创建客户-新建联系人-->
        <el-dialog
            v-model="dialogVisible"
            width="860"
            style="min-width: 600px"
            :append-to-body="true"
            @close="cancelClick"
            top="10em"
            :close-on-click-modal="false"
            :title="isEdit?$t('common.email.updateContacts'):$t('common.contact.add')"
        >
          <!--          <div class="tops">-->
          <!--            <div class="span_block"></div>-->
          <!--            <div class="inner_text">{{ $t("contact.info") }}</div>-->
          <!--          </div>-->
          <el-form
              ref="ruleFormDom"
              :model="ruleFormUsers"
              label-width="50px"
              class="demo-ruleForm-ssssss"
          >
            <el-checkbox
                style="margin-left: 12px;font-size: 13px !important;"
                :label="$t('common.mainContact')"
                v-model="ruleFormUsers.isMain"
            />
            <div style="max-height: 1000px;height:max-content;overflow:hidden scroll;margin-top: 12px;">
              <div style="display: flex;width:100%;align-items: center">
                <div class="contact_my">
                  <el-form-item
                      :label="$t('common.name')"
                      prop="name"
                      :rules="[{required: true, message: $t('form.contact.name.reg'), trigger: ['blur']}]"
                  >
                    <el-input
                        size="small"
                        v-model="ruleFormUsers.name"
                        :placeholder="$t('90201')"
                    />
                  </el-form-item>
                </div>
                <div class="contact_my">
                  <el-form-item
                      :label="$t('common.user.nick1')"
                      prop="nickName"
                  >
                    <el-input
                        size="small"
                        v-model="ruleFormUsers.nickName"
                        :placeholder="$t('common.please.input')"
                    />
                  </el-form-item>
                </div>
                <div class="contact_my">
                  <el-form-item :label="$t('common.sex')" prop="sex">
                    <!--                                <el-radio-group-->
                    <!--                                    size="small"-->
                    <!--                                    v-model="ruleFormUsers.sex"-->
                    <!--                                    class="ml-4"-->
                    <!--                                >-->
                    <!--                                  <el-radio :label="1" :value="1">{{-->
                    <!--                                      $t("common.man")-->
                    <!--                                    }}-->
                    <!--                                  </el-radio>-->
                    <!--                                  <el-radio :label="2" :value="2">{{-->
                    <!--                                      $t("common.woman")-->
                    <!--                                    }}-->
                    <!--                                  </el-radio>-->
                    <!--                                </el-radio-group>-->
                    <el-select
                        v-model="ruleFormUsers.sex"
                        size="small"
                        class="ml-4"
                        :placeholder="$t('common.please.select')"
                        style="width: 120px"
                    >
                      <el-option :label="$t('common.man')" :value="1"/>
                      <el-option :label="$t('common.woman')" :value="2"/>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="contact_my">
                  <el-form-item
                      :label="$t('common.dateofbirth')"
                      prop="birthday"
                  >
                    <el-date-picker
                        size="small"
                        v-model="ruleFormUsers.birthday"
                        type="date"
                        :placeholder="$t('common.please.select')"
                    />
                  </el-form-item>
                </div>
              </div>
              <div style="display: flex;width:100%;align-items: center;">
                <div class="contact_my">
                  <el-form-item
                      :label="$t('common.department')"
                      prop="phone"
                  >
                    <el-input
                        size="small"
                        v-model="ruleFormUsers.departName"
                        :placeholder="$t('common.please.input')"
                    />
                  </el-form-item>
                </div>
                <div class="contact_my">
                  <el-form-item
                      :label="$t('common.company.position')"
                      prop="post"
                  >
                    <el-input
                        size="small"
                        v-model="ruleFormUsers.post"
                        :placeholder="$t('sys.tip.input.position')"
                    />
                  </el-form-item>
                </div>
                <div class="contact_my">
                  <el-form-item
                      :label="$t('common.remark')"
                      prop="remark"
                  >
                    <el-input
                        size="small"
                        v-model="ruleFormUsers.remark"
                        :placeholder="$t('sys.tip.input.remark')"
                        @click="remarkDesSalVisible = true"
                    />
                    <el-dialog v-model="remarkDesSalVisible" :title="$t('common.remark')">
                      <template #default>
                        <el-input
                            style="white-space: pre-wrap;word-break: break-all"
                            v-model="ruleFormUsers.remark"
                            type="textarea"
                            :rows="5"
                            size="small"
                            :placeholder="$t('common.please.input')"
                        />
                      </template>
                      <template #footer style="border-top: 1px solid">
                        <div class="dialog-footer">
                          <el-button size="small" @click="remarkDesSalVisible = false"
                                     style="margin-right: 20px"
                          >{{ $t('common.sss16') }}
                          </el-button
                          >
                          <el-button
                              size="small"
                              type="primary"
                              @click="remarkDesSalVisible = false"
                          >{{ $t('common.save') }}
                          </el-button
                          >
                        </div>
                      </template>
                    </el-dialog>
                  </el-form-item>
                </div>
                <!--                              <div class="contact_my">-->
                <!--                                <el-form-item-->
                <!--                                    :label="$t('common.contact.phone')"-->
                <!--                                    prop="telPhone"-->
                <!--                                >-->
                <!--                                  <el-input-->
                <!--                                      size="small"-->
                <!--                                      v-model="ruleFormUsers.telPhone"-->
                <!--                                      :placeholder="$t('sys.tip.input.contact.phone')"-->
                <!--                                  />-->
                <!--                                </el-form-item>-->
                <!--                              </div>-->

              </div>
              <el-row :gutter="24" style="margin-top: -12px">
                <el-col :span="12" style="padding-right: 10px !important;">
                  <MyTitles :title="$t('common.emailbox')">
                    <template #content>
                      <div class="bottoms asterisk-left">
                        <el-form-item
                            :label="index===0?$t('common.emailbox'):' '"
                            class="sp_form_item vertical-form-item"
                            style="margin-top: 20px;padding-bottom: 0px"
                            v-for="(
                                          item, index
                                        ) in ruleFormUsers.mailContactEmailList"
                            :style="{marginTop:index===0? '18px !important':'8px !important'}"
                            :key="index"
                            :prop="
                                            'mailContactEmailList[' +
                                            index +
                                            '].content'
                                          "
                            :rules="[
                                          {
                                            pattern:
                                            emailReg,
                                            message:$t('form.email.reg') ,
                                            trigger: ['change','blur'],
                                          },
                                        ]"
                        >
                          <div class="email-input">
                            <el-input
                                size="small"
                                v-model="item.content"
                                :placeholder="$t('90201')"
                                @input="handleCheckForm(3,item)"
                            />
                            <el-button
                                link
                                class="danger_delete_btn_link"
                                size="small"
                                type="danger"
                                style="
                                                                       margin: 0px 5px !important;
                                                                        cursor: pointer;
                                                                      "
                                @click="removeEmail(index,item)"
                            >
                              {{ $t('common.delete') }}
                            </el-button>
                          </div>
                          <el-button
                              v-if="index===ruleFormUsers.mailContactEmailList.length-1"
                              size="small"
                              link
                              style="margin-top: 20px;"
                              @click="addEmail"
                              type="primary"
                          >
                            <template #icon>
                              <el-icon>
                                <Plus/>
                              </el-icon>
                            </template>
                            {{ $t('common.add') }}
                          </el-button>
                          <div v-else style="width: 93px !important;"></div>
                        </el-form-item>
                        <!--                                      <el-form-item-->
                        <!--                                          style="margin: 0px !important;justify-content: start !important;margin-top: 15px !important;">-->
                        <!--                                        <el-button-->
                        <!--                                            v-if="!ruleFormUsers.mailContactEmailList.length>0"-->
                        <!--                                            size="small"-->
                        <!--                                            @click="addEmail"-->
                        <!--                                            :icon="Plus"-->
                        <!--                                            type="primary"-->
                        <!--                                        >-->
                        <!--                                          {{ $t("common.add") }}-->
                        <!--                                        </el-button>-->
                        <!--                                      </el-form-item>-->
                      </div>
                    </template>
                  </MyTitles>
                </el-col>
                <el-col :span="12" style="padding-right: 10px !important;">
                  <MyTitles :title="$t('common.contact.phone')">
                    <template #content>
                      <div class="bottoms asterisk-left">
                        <el-form-item
                            :label-width="39"
                            :label="index===0?$t('common.contact.phone'):' '"
                            class="sp_form_item vertical-form-item"
                            style="margin-top: 20px;padding-bottom: 0px;"
                            v-for="(item, index) in ruleFormUsers.contactPhoneList"
                            :style="{marginTop:index===0?'18px !important':'8px !important'}"
                            :key="index"
                            :prop="'contactPhoneList['+index +'].content'"
                        >
                          <div class="email-input">
                            <el-input
                                size="small"
                                v-model="item.content"
                                :placeholder="$t('common.please.input')"
                            />
                            <el-button
                                link
                                class="danger_delete_btn_link"
                                size="small"
                                type="danger"
                                style="
                                              margin: 0px 5px !important;
                                              cursor: pointer;
                                              "
                                @click="removePhone(index,item)"
                            >
                              {{ $t('common.delete') }}
                            </el-button>
                          </div>
                          <el-button
                              style="margin-top: 20px;"
                              v-if="index===ruleFormUsers.contactPhoneList.length-1"
                              size="small"
                              @click="addPhone"
                              type="primary"
                              link
                          >
                            <template #icon>
                              <el-icon>
                                <Plus/>
                              </el-icon>
                            </template>
                            {{ $t('common.add') }}
                          </el-button>
                          <div v-else style="width: 93px !important;"></div>
                        </el-form-item>
                      </div>
                    </template>
                  </MyTitles>
                </el-col>
              </el-row>
              <el-row :gutter="24" style="margin-top: 20px">
                <el-col :span="12" style="padding-right: 10px !important;">
                  <MyTitles :title="$t('common.she.mei')">
                    <template #content>
                      <div class="bottoms asterisk-left">
                        <el-form-item
                            :label="index===0?$t('common.she.mei'):' '"
                            class="sp_form_item vertical-form-item"
                            style="margin-top: 20px;padding-bottom: 0px"
                            v-for="(item, index) in ruleFormUsers.contactWayList"
                            :style="{marginTop:index===0? '18px !important':'8px !important'}"
                            :key="index"
                            :prop="'contactWayList[' +index +'].content'"
                        >
                          <div class="email-input">
                            <el-input
                                size="small"
                                v-model="item.content"
                                :placeholder="$t('common.please.input')"
                            />
                            <el-button
                                link
                                class="danger_delete_btn_link"
                                size="small"
                                type="danger"
                                style="margin: 0px 5px !important;cursor: pointer;"
                                @click="removeText(index,item)"
                            >
                              {{ $t('common.delete') }}
                            </el-button>
                          </div>
                          <el-button
                              v-if="index===ruleFormUsers.contactWayList.length-1"
                              size="small"
                              @click="addText"
                              type="primary"
                              style="margin-top: 20px;"
                              link
                          >
                            <template #icon>
                              <el-icon>
                                <Plus/>
                              </el-icon>
                            </template>
                            {{ $t('common.add') }}
                          </el-button>
                          <div v-else style="width: 93px !important;"></div>
                        </el-form-item>
                      </div>
                    </template>
                  </MyTitles>
                </el-col>
                <el-col :span="12" style="padding-left: 10px !important;padding-right: 10px !important;">
                  <MyTitles :title="$t('common.memorialday')">
                    <template #content>
                      <div class="remembers asterisk-left">
                        <!-- <RememberDate></RememberDate> -->
                        <div style="width: 100% !important;">
                          <div
                              v-for="(event, index) in ruleFormUsers.mailContactSouvenirList"
                              :key="index"
                              style="display: flex;flex-direction: column"
                          >
                            <div style="width: 100%;" class="event-input">
                                            <span
                                                style="width: 48px;font-size: 13px;color: #000;padding-left: 2px">
                                              {{
                                                index === 0 ? $t('common.memorialday') : ''
                                              }}
                                            </span>
                              <el-input
                                  size="small"
                                  v-model="event.remark"
                                  :placeholder="$t('common.contact.info.anniversary.name')"
                                  ref="inputRef"
                                  style="width: 50% !important;"
                              ></el-input>
                              <div style="margin: 0 10px"></div>
                              <el-date-picker
                                  size="small"
                                  v-model="event.souvenirDay"
                                  type="date"
                                  class="event-text"
                                  :placeholder="$t('common.please.select')"
                                  style="width: 40% !important;"
                              />
                              <div class="setting">
                                <el-button
                                    size="small"
                                    v-if="event.showButtons"
                                    @click="removeEvent(index)"
                                    link
                                    style="margin: 0px 5px !important;"
                                    type="danger"
                                >{{ $t("common.delete") }}
                                </el-button>
                                <el-button
                                    size="small"
                                    v-if="!event.showButtons"
                                    @click="removeEvent(index)"
                                    link
                                    style="margin: 0px 5px !important;"
                                    type="danger"
                                >{{ $t("common.delete") }}
                                </el-button>
                              </div>
                            </div>
                            <div style="margin-top: 5px;margin-left: 38px;">
                              <el-button v-if="index===ruleFormUsers.mailContactSouvenirList.length-1"
                                         size="small"
                                         @click="addEvent" type="primary"
                                         link
                              >
                                <template #icon>
                                  <el-icon>
                                    <Plus/>
                                  </el-icon>
                                </template>
                                {{ $t('common.add') }}
                              </el-button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </MyTitles>
                </el-col>
              </el-row>
            </div>
          </el-form>
          <template #footer>
                        <span class="dialog-footer">
                          <el-button
                              size="small"
                              style="margin: 0px 6px"
                              @click="cancelClick"
                          >{{ $t("common.cancel") }}</el-button
                          >
                          <el-button
                              size="small"
                              style="margin: 0px 6px"
                              type="primary"
                              @click="addCustomerContact"
                          >
                            {{ $t("common.save") }}
                          </el-button>
                        </span>
          </template>
        </el-dialog>
      </Cards>
      <!--      <Cards v-if="isShowButton">-->
      <!--        <div>-->
      <!--          <div style="display: flex;justify-content: center;align-items: center">-->
      <!--            <el-button size="small" style="margin: 0px 8px !important" @click="reBack"-->
      <!--            >{{ $t('common.back') }}-->
      <!--            </el-button-->
      <!--            >-->
      <!--            <el-button-->
      <!--                size="small"-->
      <!--                :loading="saveDataIsLoading"-->
      <!--                style="margin: 0px 8px !important"-->
      <!--                type="primary"-->
      <!--                @click="saveData"-->
      <!--            >{{ $t('common.save') }}-->
      <!--            </el-button-->
      <!--            >-->
      <!--          </div>-->
      <!--        </div>-->
      <!--      </Cards>-->
    </el-form>
  </div>

  <el-popover
      v-model:visible="visiblePopover"
      :virtual-ref="tempRef"
      virtual-triggering
      :popper-style="{ minWidth: '60px', width: 'auto' }"
      trigger="hover"
      effect="dark"
      :show-after="1200"
  >
    <template v-if="popoverType === 1">
      <!-- 业务逻辑1 -->
      <div class="popover-content">
        {{ activeItemElpopover.name }}
      </div>
    </template>
    <template v-if="popoverType === 2">
      <!-- 业务逻辑1 -->
      <div class="popover-content">
        {{ activeItemElpopover.nickName }}
      </div>
    </template>
    <template v-if="popoverType === 3">
      <!-- 业务逻辑1 -->
      <div class="popover-content">
        {{ activeItemElpopover.email }}
      </div>
    </template>
    <template v-if="popoverType === 4">
      <!-- 业务逻辑1 -->
      <div class="popover-content">
        {{ activeItemElpopover.departName }}
      </div>
    </template>
    <template v-if="popoverType === 5">
      <!-- 业务逻辑1 -->
      <div class="popover-content">
        {{ activeItemElpopover.post }}
      </div>
    </template>
    <template v-if="popoverType === 6">
      <!-- 业务逻辑1 -->
      <div class="popover-content">
        {{ activeItemElpopover?.contactPhone }}
      </div>
    </template>
    <template v-if="popoverType === 7">
      <!-- 业务逻辑1 -->
      <div class="popover-content">
        {{ activeItemElpopover?.createTime }}
      </div>
    </template>
  </el-popover>

</template>

<script setup>
import {
  computed,
  ref,
  onMounted,
  reactive,
  defineProps,
  defineExpose,
  defineEmits,
  inject,
  nextTick,
  watch,
  watchEffect
} from "vue";
import {useStore} from "vuex";
import {useRoute, useRouter} from "vue-router";
import {v4 as uuidv4} from 'uuid';
import Cards from "../Cards.vue";
import MoreCheck from "./MoreCheck.vue";
import {debouncePlus, isEmpty, throttle} from "@/utils/mylodash"
import {customerCodeReg, emailReg, emptyUrl, POPOVER_DELAY_TIME, TIME_OUT} from "@/utils/statusParams";
import ConfirmDeletePopover from "@/components/ConfirmDeletePopover.vue";
import {Memo, Plus, User} from "@element-plus/icons-vue";
import MyTitles from "@/views/Customer/Detail/MyTitles.vue";
import {ElMessage, ElTable} from "element-plus";
import dayjs from "dayjs";
import {i18n} from "@/lang";
import {checkEmailAndWebsite, checkMainContact} from "@/api/customer";
import SelectEditTag from "@/components/SelectEditTag.vue";
import {Storage} from "@/utils/storage";
import {getTextLength} from "@/utils/util";
import {formatText} from "../../../utils/util";
import SessionStore from "@/utils/sessionStore";
import sessionStore from "@/utils/sessionStore";

const router = useRouter();
const route = useRoute();
const store = useStore();
const emit = defineEmits()
const {isCreate, isShowButton, isShowTitleSp} = defineProps({
  isShowButton: {
    type: Boolean,
    default: true
  },
  isCreate: {
    type: Boolean,
    default: false
  },
  isShowTitleSp: {
    type: Boolean,
    default: false
  }
})
const customerSelectData = computed(() => store.state.cusList.customerSelectData);
const empty = ref(i18n.global.t('select.empty'))
const remarkDesSalVisible = ref(false)
const teamId = computed(() => store.state.email.teamID)

// 编辑
const isEdit = ref(false);
// 添加联系人
const dialogVisible = ref(false);
const targetMaps = [
  {key: i18n.global.t('common.name'), value: "name"},
  {key: i18n.global.t('common.user.nick1'), value: "nickName"},
  {key: i18n.global.t('common.emailbox'), value: "email"},
  {key: i18n.global.t('common.department'), value: "departName"},
  {key: i18n.global.t('common.position'), value: "post"},
  {key: i18n.global.t('common.contact.phone'), value: "contactPhone"},
  {key: i18n.global.t('common.birthday'), value: "birthday"},
  {key: i18n.global.t('common.record.time'), value: "createTime"},
  {key: i18n.global.t('common.remark'), value: "remark"},
];
const isLoading = ref(false);
// 表单数据
const ruleFormUsers = reactive({
  departName: "",
  name: "",
  sex: 1,
  post: "",
  telPhone: "",
  birthday: null,
  remark: "",
  nickName: "",
  isMain: false,
  contactWayList: [
    {
      content: "",
      isDefault: 1,
    }
  ],
  contactPhoneList: [
    {
      content: "",
      isDefault: 1,
    }
  ],
  mailContactEmailList: [
    {
      content: "",
      isDefault: 1,
    },
  ],
  mailContactSouvenirList: [
    {
      remark: "",
      souvenirDay: "",
      editing: true,
      showButtons: true,
    }
  ],
});

const cancelClick = () => {
  dialogVisible.value = false;
  isEdit.value = false
  ruleFormUsers.name = "";
  ruleFormUsers.sex = 1;
  ruleFormUsers.post = "";
  ruleFormUsers.phone = "";
  ruleFormUsers.telPhone = "";
  ruleFormUsers.birthday = null;
  ruleFormUsers.teamId = "";
  ruleFormUsers.remark = "";
  ruleFormUsers.departName = "";
  ruleFormUsers.nickName = ""
  ruleFormUsers.isMain = false;
  ruleFormUsers.contactWayList = [
    {content: "", isDefault: 1}
  ]
  ruleFormUsers.contactPhoneList = [
    {content: "", isDefault: 1}
  ]
  ruleFormUsers.mailContactEmailList = [
    {
      content: "", isDefault: 1,
    },
  ];
  ruleFormUsers.mailContactSouvenirList = [{
    remark: "",
    souvenirDay: "",
    editing: true,
    showButtons: true,
  }];
};

const editEvent = (index) => {
  ruleFormUsers.mailContactSouvenirList[index].editing = false;
  nextTick(() => {
    inputRefs[index].focus();
  });
};

const updateEvent = (index) => {
  ruleFormUsers.mailContactSouvenirList[index].editing = true;
  ruleFormUsers.mailContactSouvenirList[index].showButtons = true;
};

const removeEvent = (index) => {
  if (ruleFormUsers.mailContactSouvenirList.length === 1) {
    return
  }
  ruleFormUsers.mailContactSouvenirList.splice(index, 1);
};

const showButtons = (index) => {
  ruleFormUsers.mailContactSouvenirList[index].showButtons = true;
};

const hideButtons = (index) => {
  ruleFormUsers.mailContactSouvenirList[index].showButtons = false;
  ruleFormUsers.mailContactSouvenirList[index].editing = false;

  if (ruleFormUsers.mailContactSouvenirList[index].remark === "") {
    removeEvent(index);
  }
};


// 添加纪念日
const dates = ref([{value: new Date()}]);
const addEvent = () => {
  ruleFormUsers.mailContactSouvenirList.push({
    remark: "",
    souvenirDay: "",
    editing: true,
    showButtons: true,
  });
  dates.value.push({value: new Date()});
};


const addEmail = () => addContactItem('mailContactEmailList', 'content');
const addPhone = () => addContactItem('contactPhoneList', 'content');
const addText = () => addContactItem('contactWayList', 'content')

const addContactItem = (listKey, fieldKey = 'email') => {
  const list = ruleFormUsers[listKey];

  // 1️⃣ 判断是否已有空字段
  // const hasEmpty = list.some((item) => item[fieldKey] === '');
  // if (hasEmpty) {
  //   ElMessage.error(i18n.global.t('detail.add.customer'));
  //   return;
  // }

  // 2️⃣ 添加一个新项
  list.push({
    [fieldKey]: '',
    isDefault: 0,
  });

  // 3️⃣ 确保第一个为默认项
  if (list.length > 0) {
    list[0].isDefault = 1;
  }
};


// 原数据
const tableData = reactive([])
// table 可以被识别的数据
let targetTableData = []
const mainKey = ref(1)
const ruleFormDom = ref(null);

// 添加联系人
const addCustomerContact = throttle(() => {
  ruleFormDom.value.validate(async (valid, fields) => {
    if (valid) {
      // 深拷贝表单数据
      try {


        const copObj = JSON.parse(JSON.stringify(ruleFormUsers))
        const {mailContactSouvenirList, mailContactEmailList, contactPhoneList, contactWayList} = copObj

        // 🎯 格式化纪念日
        const resMails = mailContactSouvenirList.map(item => ({
          ...item,
          souvenirDay: item.souvenirDay && dayjs(item.souvenirDay).isValid()
              ? dayjs(item.souvenirDay).format("YYYY-MM-DD")
              : null,
        }))

        // 🎯 处理默认邮箱
        const hasDefault = mailContactEmailList.some(item => item.isDefault === 1)
        const selectDefault = hasDefault
            ? mailContactEmailList.filter(_ => _.content !== "")
            : mailContactEmailList
                .map((item, index) => ({
                  ...item,
                  isDefault: index === 0 ? 1 : 0,
                }))
                .filter(_ => _.content !== "")

        // 默认处理电话
        const hasDefaultPhone = contactPhoneList.some(item => item.isDefault === 1)
        const selectDefaultPhone = hasDefaultPhone
            ? contactPhoneList.filter(_ => _.content !== "")
            : contactPhoneList
                .map((item, index) => ({
                  ...item,
                  isDefault: index === 0 ? 1 : 0,
                }))
                .filter(_ => _.content !== "")

        // 默认处理新媒体
        const hasDefaultWay = contactWayList.some(item => item.isDefault === 1)
        const selectDefaultWay = hasDefaultWay
            ? contactWayList.filter(_ => _.content !== "")
            : contactWayList
                .map((item, index) => ({
                  ...item,
                  isDefault: index === 0 ? 1 : 0,
                }))
                .filter(_ => _.content !== "")

        delete copObj.birthday
        // delete copObj.mailContactSouvenirList
        // delete copObj.mailContactEmailList

        // 🎯 组装最终对象
        const targetObj = {
          ...copObj,
          birthday: ruleFormUsers.birthday && dayjs(ruleFormUsers.birthday).isValid()
              ? dayjs(ruleFormUsers.birthday).format("YYYY-MM-DD")
              : null,
          mailContactSouvenirList: resMails,
          mailContactEmailList: selectDefault,
          contactPhoneList: selectDefaultPhone,
          contactWayList: selectDefaultWay,
          teamId: teamId.value,
          email: copObj.mailContactEmailList.find(item => item.isDefault === 1)?.content,
          contactPhone: copObj.contactPhoneList.find(item => item.isDefault === 1)?.content,
          // isMain: ruleFormUsers.isMain ? 1 : 0, // ✅ 保留字段
        }

        // ✅ 处理 tableData 保证只有一个 isMain
        const resetMainFlag = () => {
          tableData.forEach(item => {
            item.isMain = false
          })
        }

        // console.log(targetObj,'targetObj')
        if (!isEdit.value) {
          console.log("添加", targetObj)
          // 每次添加前如果是主联系人则重置旧的
          if (targetObj.isMain) resetMainFlag()

          const newItem = {...targetObj, id: uuidv4()}
          tableData.push(newItem)
          sessionStore.set("tableData", tableData)
          // localStorage.setItem("tableData", JSON.stringify(tableData))
        } else {
          console.log("编辑", targetObj)
          // 如果编辑时设为主联系人，也要重置旧的
          if (targetObj.isMain) resetMainFlag()

          // 更新对应项
          const updated = tableData.map(item =>
              item.id === contactId.value ? {...item, ...targetObj} : item
          )

          tableData.splice(0, tableData.length, ...updated)
          // localStorage.setItem("tableData", JSON.stringify(tableData))
          sessionStore.set("tableData", tableData)
        }

        // ✅ 关闭弹窗 & 重置表单
        dialogVisible.value = false
        isEdit.value = false
        ruleFormDom.value.resetFields()
      } catch (e) {
        console.log(e)
      }
    } else {

    }
  })
}, 500)

// 记录联系人行id
const contactId = ref("");
// 编辑联系人
const clickEdit = async (row, column, $index) => {
  console.log(row, 'row')
  isEdit.value = true;
  const {id} = row;
  contactId.value = id;
  dialogVisible.value = true;
  const contactMessage = targetTableData.value.filter(item => item.id === id)[0]
  const {
    name,
    post,
    phone,
    telPhone,
    birthday,
    remark,
    sex,
    mailContactEmailList,
    mailContactSouvenirList,
    contactPhoneList,
    contactWayList,
    departName,
    nickName,
    isMain = 0,
  } = contactMessage;
  // ✅ 通用字段
  Object.assign(ruleFormUsers, {
    teamId: teamId.value,
    name,
    post,
    phone,
    telPhone,
    birthday,
    sex,
    remark,
    departName,
    nickName,
    isMain, // 如果你在 <el-checkbox> 里用了 true-label / false-label，这里直接能用
  })
  ruleFormUsers.contactWayList = contactWayList.length > 0 ? contactWayList : [
    {
      content: "",
      isDefault: 1,
    }]
  ruleFormUsers.contactPhoneList = contactPhoneList.length > 0 ? contactPhoneList : [
    {
      content: "",
      isDefault: 1,
    }]

// ✅ 邮箱列表：保证至少有一个空项
  ruleFormUsers.mailContactEmailList = mailContactEmailList.length > 0
      ? mailContactEmailList
      : [
        {
          content: "",
          isDefault: 1,
        },
      ]

// ✅ 纪念日列表：保证至少有一个空项
  ruleFormUsers.mailContactSouvenirList = mailContactSouvenirList.length > 0
      ? mailContactSouvenirList
      : [
        {
          remark: "",
          souvenirDay: "",
          editing: true,
          showButtons: true,
        },
      ]
};


const removeEmail = (index) => {
  removeContactItem('mailContactEmailList', index)
};

const removePhone = (index) => {
  removeContactItem('contactPhoneList', index)
}

const removeText = (index) => {
  removeContactItem('contactWayList', index)
}

const removeContactItem = (flag, index) => {
  ruleFormUsers[flag].splice(index, 1);
}

const handleDelete = async (row, column, $index) => {
  tableData.splice(tableData.findIndex(item => item.id === row.id), 1)
  // localStorage.setItem("tableData", JSON.stringify(tableData))
  sessionStore.set("tableData", tableData)
  row.popoverVisible = false;
};

const handleDeleteT = async (row, column, $index) => {
  row.popoverVisible = true;
}


watch(
    () => tableData,
    (newValue, oldValue) => {
      console.log(newValue, oldValue, 'tableData')

      targetTableData = computed(() => {
        const tableDataTrue = newValue || []
        let result = []
        if (tableDataTrue) {
          result = tableDataTrue.map(item => ({
            ...item,
            content: item.mailContactEmailList.filter(_ => _.isDefault === 1)[0]?.email,
            popoverVisible: false,
          }))

          // 🔹 排序：isMain 为 true 的排在最上面
          result.sort((a, b) => {
            if (a.isMain === b.isMain) return 0
            return a.isMain ? -1 : 1
          })
        }
        return result
      })

      console.log(targetTableData.value, 'targetTableDataddddd')
    },
    {deep: true}
)
//--------


const ruleForm = computed(() => store.state.customer.ruleForm);
const form = computed(() => store.state.customer.form);
const selections = computed(() => store.state.cusList.tableData);
const selectTarget = computed(() => store.state.customer.selectTarget);


// 计算手机号
const defaultPhoneNumber = computed({
  get() {
    const defaultPhone = form.value.phones.find(item => item.isDefault);
    return defaultPhone ? defaultPhone.phoneNumber : form.value.phones.length >= 1 ? form.value.phones[0].phoneNumber : [];
  },
  set(value) {
    const defaultPhone = form.value.phones.find(item => item.isDefault);
    if (defaultPhone) {
      defaultPhone.phoneNumber = value;
    } else {
      form.value.phones.push({phoneNumber: '', isDefault: true})
    }
  }
});
// 计算邮箱
const defaultEmail = computed({
  get() {
    const defaultEmailCurrent = form.value.emails.find(item => item.isDefault);
    return defaultEmailCurrent ? defaultEmailCurrent.email : form.value.emails.length >= 1 ? form.value.emails[0].email : [];
  },
  set(value) {
    const defaultEmailCurrent = form.value.emails.find(item => item.isDefault);
    if (defaultEmailCurrent) {
      defaultEmailCurrent.email = value;
    } else {
      form.value.emails.push({email: '', isDefault: true})
    }
  }
});

const isSelected = computed(() => store.state.customer.isSelected)
const customerCodeEmpty = (rule, value, callback) => {
  if (ruleForm.value.customerCodeDefault === '') {
    callback(new Error("客户编号不能为空"));
  } else {
    // 选中了
    if (customerCodeReg.test(ruleForm.value.customerCode)) {
      callback()
    } else {
      callback(new Error("客户编号长度不能超过30个字符"));
    }
  }
}


const ruleFormRef = ref(null);
const rules = reactive({
  customerCode: [{
    validator: customerCodeEmpty,
    trigger: ["change", "blur"],
  }],
  name: [{required: true, message: "联系人姓名不能为空", trigger: ["change", "blur"]}],
  email: [
    {
      pattern: emailReg,
      message: '您输入的邮箱不符合规定',
      trigger: ["change", "blur"],
    }
  ],
  zoneAddress:
      [{required: true, message: "区域不能为空", trigger: ["change", "blur"]}],
  customerName:
      [{required: true, message: "客户名称不能为空", trigger: ["change", "blur"]}],
});


const disabledDate = (time) => {
  return time.getTime() > Date.now();
};

// 选择
const selectChange = async (val) => {
  if (val) {
    let target = selections.value.filter((item) => item.id === val)[0];
    await store.commit("customer/changeSelect", target.customerType);
  } else {
    await store.commit("customer/changeSelect", "");
  }
};

let otherDesCompanyVisible = ref(false);
const otherDesSalVisible = ref(false);
const showTextarea = () => {
  // 获取客户信息
  otherDesCompanyVisible.value = true;
};

const saveOtherDesCompany = () => {
  otherDesCompanyVisible.value = false;
};

let sendMoneytoYe = null;
try {
  const moneySendGrandson = inject('moneySendGrandson');
  if (typeof moneySendGrandson === 'function') {
    sendMoneytoYe = function () {
      moneySendGrandson(3000);
    };
  } else {
    throw new Error('moneySendGrandson is not a function');
  }
} catch (e) {
}


// 表单更换结构
// const enterToSpace = computed(() => {
//   return JSON.parse(JSON.stringify(ruleForm.value.marketingRemark).replace(/^\\n$/g, '&nbsp;'))
// })
const saveDataIsLoading = computed(() => store.state.customer.saveDataIsLoading)
// 提交用户信息
const saveData = throttle(async () => {
          return ruleFormRef.value.validate(async (valid) => {
            if (valid) {
              console.log("校验成功");
              otherDesSalVisible.value = false;
              console.log('ruleForm', ruleForm.value, tableData.value)
              // 数据格式转换
              console.log(isSaveCommit.value, 'isSaveCommit.value')
              if (isSaveCommit.value) {
                const res = await store.dispatch(
                    "customer/saveActivity", {teamId: teamId.value, isNoJump: false}
                );
                if (res) {
                  tableData.splice(0, tableData.length);
                  await store.commit('customer/changeSelect', '')
                  // 清除缓存
                  // await localStorage.setItem("ContactMessage", JSON.stringify([]))
                  // await localStorage.setItem("tableData", JSON.stringify([]))
                  await sessionStore.set("ContactMessage", []);
                  await sessionStore.set("tableData", []);
                  await sessionStore.remove("formDetail")
                }
                try {
                  sendMoneytoYe()
                } catch (e) {
                  console.log(e)
                }
                try {
                  _scrollTo("created_customer")
                } catch (e) {
                }
              } else {
                const customerType = computed(() => store.state.customer.selectTarget);
                console.log("未保存", customerType.value);
                try {
                  await store.dispatch("customer/UpdateActivity", {
                    customerType: customerType.value,
                    isAlert: true,
                    teamId: teamId.value
                  });
                  // 同步数据 回现
                  SessionStore.set("formDetail", form.value)
                  // 遍历 emails 进行更新或新增
                  await store.dispatch("customer/getQueryById", {customerId: SessionStore.get("customerId")});
                  const targetForm = SessionStore.get("formDetail")
                  syncIds(ruleForm.value, targetForm);
                  // console.log(ruleForm.value, 'ruleForm_')
                  // console.log(form.value, 'ruleForm_')
                  // ruleForm.value.emailWayList =
                  window.preData = ruleForm.value?.customerCode
                } catch (e) {
                  console.log(e)
                }
              }
              // 重制选择
              store.commit("customer/setIsSelected", false)
            } else {
              console.log("校验失败");
              await nextTick(() => {
                // 获取错误节点
                let isError = ruleFormRef.value.$el.getElementsByClassName('is-error')
                isError[0].scrollIntoView({
                  // 滚动到指定节点
                  // 值有start,center,end，nearest，当前显示在视图区域中间
                  block: 'center',
                  // 值有auto、instant,smooth，缓动动画（当前是慢速的）
                  behavior: 'smooth',
                })
              })
              return false;
            }
          });
        },
        1000
    )
;

function syncIds(ruleForm, form) {
  // ------- 1. 匹配 email -------
  const emailMap = new Map();
  ruleForm.emailWayList?.forEach(item => {
    if (item.content) {
      emailMap.set(item.content, item.id);
    }
  });

  form.emails?.forEach(item => {
    const id = emailMap.get(item.email);
    if (id) item.id = id;
  });

  // ------- 2. 匹配 phone -------
  const phoneMap = new Map();
  ruleForm.phoneWayList?.forEach(item => {
    if (item.content) {
      phoneMap.set(item.content, item.id);
    }
  });

  form.phones?.forEach(item => {
    const id = phoneMap.get(item.phoneNumber);
    if (id) item.id = id;
  });

  console.log("同步完成后的 form:", form);
  store.commit("customer/setForm", form)
}


defineExpose({saveData, ruleFormRef})
// 返回
const reBack = async () => {
  // 清除联系人相关的内容
  // await localStorage.setItem("ContactMessage", JSON.stringify([]))
  // await localStorage.setItem("tableData", JSON.stringify([]))
  await sessionStore.set("ContactMessage", [])
  await sessionStore.set("tableData", [])
  await sessionStore.remove("formDetail")
  router.push({
    path: `/email/customer/list`,
  });
};

function _scrollTo(id) {
  var _id = document.getElementById(id);
  console.log("id", _id)
  document.querySelector('.view').scrollTo({
    top: _id.offsetTop,
    behavior: 'smooth'
  });
}


const isSaveCommit = ref(true);
onMounted(async () => {
  // 保留用户表单信息
  // const result = computed(() => {
  //   const tableDataTrue = JSON.parse(localStorage.getItem("tableData")) || []
  //   let result = []
  //   if (tableDataTrue) {
  //     result = tableDataTrue.map(item => ({
  //       ...item,
  //       email: item.mailContactEmailList.filter(_ => _.isDefault === 1)[0]?.email,
  //       popoverVisible: false,
  //     }))
  //   }
  //   return result
  // })
  // Object.assign(tableData, result.value)
  // console.log(result.value, tableData,
  //     'targetTableData'
  // )
  console.log(teamId.value, "团队id");
  await store.dispatch("cusList/getMailCustomerLevel", {teamId: teamId.value});
  await store.commit('customer/setCustomerLevels', selections.value)
  const res = router.currentRoute.value.name;
  console.log(res, '@@')
  if (res === "Create" || res === "Inbox" || res === "HasSend" || res === 'DetailEmail' || res === 'Success') {
    isSaveCommit.value = true;
  } else {
    isSaveCommit.value = false;
  }
  // await store.dispatch("cusList/getCustomerSelectDataFunction", {
  //   teamId: teamId.value,
  //   type: 1,
  // })
});

// 公司地址 相关信息进行后端校验
const companyWebSite = ref("")
const email = ref("")
const handleCheckForm = debouncePlus(async (type, item) => {
  if (type === 1) {
    console.log('公司网址', ruleForm.value)
    const payload = {
      teamId: teamId.value,
      companyWebsite: ruleForm.value.companyWebsite
    }
    if (route.params.userId) {
      payload.customerId = route.params.userId
    }
    const res = await checkEmailAndWebsite(payload)
    if (!isEmpty(res.result) && res.result.companyWebsite !== "ok" && res.result.companyWebsite !== '' && ruleForm.value.companyWebsite !== '') {
      ElMessage.warning(res.result.companyWebsite)
    }
  } else if (type === 2) {
    console.log('公司邮箱', ruleForm.value)
    const payload = {
      teamId: teamId.value,
      email: defaultEmail.value
    }
    if (route.params.userId) {
      payload.customerId = route.params.userId
    }
    const res = await checkEmailAndWebsite(payload)
    if (!isEmpty(res.result) && res.result.email !== "ok" && res.result.email !== '' && defaultEmail.value !== '') {
      ElMessage.warning(res.result.email)
    }
  } else if (type === 3) {
    console.log('联系人', ruleForm.value)
    const payload = {
      teamId: teamId.value,
      email: item.content
    }
    if (route.params.userId) {
      payload.customerId = route.params.userId
    }
    const res = await checkEmailAndWebsite(payload)
    if (!isEmpty(res.result) && res.result.email !== "ok" && res.result.email !== '' && item.email !== '') {
      ElMessage.warning(res.result.email)
    }
  }
}, TIME_OUT)


const exitMainContactFlag = ref(false)
const handleClickAdd = async () => {
//   添加联系人
  dialogVisible.value = true
  const table = Storage.get("tableData") ?? []
  console.log(table, 'table')
  if (table.length === 0) {
    ruleFormUsers.isMain = true;
  } else {
    ruleFormUsers.isMain = false;
  }
  //   try {
  //     const payload = {
  //       customerId: route.params.userId,
  //       teamId: teamId.value
  //     }
  //     const res = await checkMainContact(payload)
  //     console.log(res, 'asdfasfasfdsaf')
  //     exitMainContactFlag.value = res.result?.exitMainContact
  //     if (exitMainContactFlag.value) {
  //       ruleFormUsers.isMain = false
  //     } else {
  //       ruleFormUsers.isMain = true;
  //     }
  //   } catch (e) {
  //     ruleFormUsers.isMain = false
  //     console.log(e)
  //   }
}


const middleValueWidth = ref(160)
// 字数大致限制
const sizeMaxNumber = ref(13)
const handleClickSelectWidth = (item) => {
  if (item.value === 'birthday') {
    return 100
  } else if (item.value === 'createTime') {
    return 160
  } else if (item.value === 'remark') {
    return 80
  }
  // if (item.value === "name") {
  //   return flexWidth('name', tableData.value, i18n.global.t('common.name')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('name', tableData.value, i18n.global.t('common.name')) + 20
  // } else if (item.value === 'nickName') {
  //   return flexWidth('nickName', tableData.value, i18n.global.t('common.user.nick1')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('nickName', tableData.value, i18n.global.t('common.user.nick1')) + 20
  // } else if (item.value === 'email') {
  //   return flexWidth('email', tableData.value, i18n.global.t('common.emailbox')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('email', tableData.value, i18n.global.t('common.emailbox')) + 20
  // } else if (item.value === 'departName') {
  //   return flexWidth('departName', tableData.value, i18n.global.t('common.department')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('departName', tableData.value, i18n.global.t('common.department')) + 20
  // } else if (item.value === 'post') {
  //   return flexWidth('post', tableData.value, i18n.global.t('common.position')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('post', tableData.value, i18n.global.t('common.position')) + 20
  // } else if (item.value === 'contactPhone') {
  //   return 160
  // } else if (item.value === 'birthday') {
  //   return 160
  // } else if (item.value === 'createTime') {
  //   return flexWidth('createTime', tableData.value, i18n.global.t('common.record.time')) > middleValueWidth.value ? middleValueWidth.value : flexWidth('createTime', tableData.value, i18n.global.t('common.record.time')) + 20
  // }
}

// const handleClickSelectMinWidth = (item, type) => {
//   if (item.value === 'remark') {
//     return 80
//   } else {
//     return 160
//   }
// }

// el-popover 优化
const refMap = ref({})
const tempRef = ref()
const visiblePopover = ref(false)
// -1-字句审核 0-整句审核 1-日志查看
const popoverType = ref(0)
const activeItemElpopover = ref(null)

const handleRef = debouncePlus((ref, item, type) => {
  console.log('refMap', refMap.value)
  tempRef.value = ref
  popoverType.value = type
  activeItemElpopover.value = item;
  if (type === 1) {
    // ...业务逻辑1
  } else {
    // ...业务逻辑2、3
  }
  visiblePopover.value = true
}, POPOVER_DELAY_TIME)


const rowClassName = ({row, column, rowIndex, columnIndex}) => {
  // console.log(row, columnIndex)
  if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2 || columnIndex === 3 || columnIndex === 4 || columnIndex === 5 || columnIndex === 9) {
    return {textAlign: 'left'}
  } else {
    return {textAlign: 'center'}
  }
}

const headerClassName = ({row, column, rowIndex, columnIndex}) => {
  if (columnIndex === 0 || columnIndex === 1 || columnIndex === 2 || columnIndex === 3 || columnIndex === 4 || columnIndex === 5 || columnIndex === 9) {
    return {'text-align': 'left', background: '#f9f9f9', color: 'black', padding: '8px 0px'}
  } else {
    return {'text-align': 'center', background: '#f9f9f9', color: 'black', padding: '8px 0px'}
  }
}

const clearVisiblePopover = () => {
  setTimeout(() => {
    visiblePopover.value = false
  }, POPOVER_DELAY_TIME + 10)
}

</script>

<style lang="less" scoped>
@import "../../../views/Customer/less/detail.less";

.inner_outbox {
  display: flex;
  justify-content: flex-start;
  height: 86px !important;
}

.inner_outbox {
  .el-form-item:last-child {
    height: max-content !important;
  }
}


:deep(.el-date-editor.el-input) {
  width: 100% !important;
}

:deep(.el-select) {
  width: 100% !important;
}

:deep(.el-form-item__content) {
  justify-content: flex-start !important;
}

#submits_footer {
  height: max-content !important;
  padding: 0px !important;
  margin: 0px !important;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}


h2 {
  color: rgba(0, 0, 0, 0.85);
  font-weight: 700;
  font-size: 21px;
}

.pages {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

.top_titles {
  padding-bottom: 15px;
  border-bottom: 1px solid #ebebeb;
}

.small_box {
  width: max-content;
  margin-top: 20px;
}

:deep(.el-drawer) {
  width: 530px;
}

.box_content {
  width: 100%;

  & > div {
    background: #f5f5f5;

    .inners {
      padding: 20px;
      width: 100%;
      background: white;
    }
  }
}

h3 {
  font-size: 16px;
  font-weight: 500;
}

:deep(.el-tabs__active-bar) {
  height: 3px !important;
}

.titles {
  padding: 20px 0px;
  border-bottom: 1px solid #ebebeb;
}

:deep(.el-form-item__label) {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
}

:deep(.el-empty__image img) {
  width: 54% !important;
}

//:deep(.el-form-item:first-child) {
//  padding: 0px 24px 12px 0px;
//}

.views {
  flex-grow: 1;
  height: calc(100vh - 165px);
  overflow: hidden;
  background-color: rgb(245, 245, 245);
}

.linkUser {
  display: flex;
  overflow: hidden;
  height: calc(100vh - 182px);
}

:deep(.el-empty__description) {
  margin-top: -20px;
}

#spButton {
  margin-left: -40px !important;
}

:deep(.el-card__header) {
  margin-bottom: 10px;
}

.tops {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  border-bottom: 1px solid #e8e8e8;
  padding-bottom: 10px;
  margin-bottom: 10px;

  .span_block {
    width: 4px;
    height: 16px;
    padding-left: 5px;
    border-left: 4px solid #1890ff;
  }

  .inner_text {
    color: #000;
  }
}

label {
  font-weight: normal !important;
  font-size: 13px !important;
}

:deep(.el-table .cell) {
  font-size: 13px !important;
  font-weight: normal !important;
}

.gutter_my {
  flex: 1;
  margin: 0px 10px;
}

.gutter_my_sp {
  width: 18.4%;
  margin: 0px 10px;
}

.gutter_my_sp_form {
  width: 17.79% !important;
  margin: 0px 10px;
}

:deep(.el-form-item__label) {
  font-size: 13px !important;
  color: rgba(0, 0, 0, 0.85);
  font-weight: normal !important;
}

:deep(.el-form-item__content) {
  margin-left: 0px !important;
  flex-wrap: nowrap !important;
}

:deep(.el-form-item__content > div) {
  width: 110% !important;
}

:deep(.el-form-item) {
  margin-bottom: 15px !important;
}

:deep(.event-input) {
  margin-bottom: 13px !important;
  width: 100% !important;
}

.sp_form_item:first-child {
  margin: 18px 0px 18px 0px !important;
}

:deep(.sp_form_item) {
  height: 24px !important;
  margin-bottom: 18px !important;
}

.contact_my {
  width: 25% !important;
}

.message_sp_inbox {
  position: absolute;
  width: 250px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  top: 58px !important;
  font-size: 12px !important;
  color: #e6a23c !important;
}

.message_sp_inbox_ok {
  position: absolute;
  width: 250px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  top: 58px !important;
  font-size: 12px !important;
  color: green !important;
}

.message_sp_inbox_email {
  position: absolute;
  width: 250px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  top: 145px !important;
  font-size: 12px !important;
  color: #e6a23c !important;
}

.message_sp_inbox_email_ok {
  position: absolute;
  width: 250px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  top: 145px !important;
  font-size: 12px !important;
  color: green !important;
}


:deep(.el-tag) {
  max-width: 100px !important;
}

:deep(.el-form-item__error) {
  padding-top: 2px !important;
}

.sp_form_item {
  :deep(.el-form-item__error) {
    padding-top: 4px !important;
  }
}


.vertical-form-item {
  :deep(.el-form-item__content) {
    display: flex;
    flex-direction: column; /* 垂直排列 */
    align-items: flex-start; /* 左对齐 */
  }
}

.demo-ruleForm-ssssss {
  .sp_form_item {
    :deep(.el-form-item__label) {
      line-height: 26px !important;
    }
  }
}

.email-input {
  display: flex;
  align-items: center;
  gap: 5px;
  width: 100%;
}

:deep(.el-checkbox__label) {
  font-size: 14px !important;
  color: #000000 !important;
  font-weight: 500 !important;
}
</style>
